import React from 'react'

import ScreenContainer from 'components/ScreenContainer'

import { STRING } from 'resources'

import { Container, Scribble, Title, TitleButtonSection, TitleAccent, Content } from './styles'

const ProtectScreenHeader = () => (
  <Container>
    <Scribble />
    <Content>
      <ScreenContainer>
        <TitleButtonSection>
          <Title>
            {STRING.protect.pageTitle.part1}
            <TitleAccent>{STRING.protect.pageTitle.part2}</TitleAccent>
          </Title>
        </TitleButtonSection>
      </ScreenContainer>
    </Content>
  </Container>
)

export default ProtectScreenHeader
